import { render, staticRenderFns } from "./indexPageTable.vue?vue&type=template&id=10e7df28&scoped=true"
import script from "./indexPageTable.vue?vue&type=script&lang=js"
export * from "./indexPageTable.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/introduce-common.scss?vue&type=style&index=0&id=10e7df28&prod&lang=scss&scoped=true&external"
import style1 from "./indexPageTable.vue?vue&type=style&index=1&id=10e7df28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e7df28",
  null
  
)

export default component.exports